// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NorstellaCoverageFinder Popup Default styles */
.norstella-cf-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  display: none;
  width: 90%;
  max-width: 980px;
}

.norstella-cf-popup.norstella-cf-open {
  display: block;
}

.norstella-cf-popup-content {
  position: relative;
  min-width: 80%;
  overflow-x: auto;
  /* Horizontal scrolling */
  overflow-y: auto;
  /* Vertical scrolling */
  margin: 0 auto;
}

.norstella-cf-scrollable-content {
  margin-top: 50px;
}

#scrollable-note-content {
  overflow-y: auto;
  height: 100%;
}

.norstella-cf-note-content {
  height: 350px;
}

.norstella-cf-close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #757575;
}

.norstella-cf-note-button {
  background: none;
  border: none;
  cursor: pointer;
  padding-left: 0px;
  padding-right: 0px;
}

.norstella-cf-close-button:hover {
  color: #333;
}

/* Responsive styles */
@media (max-width: 768px) {
  .norstella-cf-popup {
    width: 95%;
    height: 80%;
    max-width: none;
    padding-left: 0;
    padding-right: 0;
  }

  .norstella-cf-popupPAForm {
    height: 70px;
  }

  .norstella-cf-popup-content {
    min-width: 90%;
    padding: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CoverageFinder/CommonComponent/DialogBox.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,uCAAuC;EACvC,aAAa;EACb,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;AACF","sourcesContent":["/* NorstellaCoverageFinder Popup Default styles */\r\n.norstella-cf-popup {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background-color: #fff;\r\n  border: 1px solid #ccc;\r\n  padding: 20px;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\r\n  z-index: 1000;\r\n  display: none;\r\n  width: 90%;\r\n  max-width: 980px;\r\n}\r\n\r\n.norstella-cf-popup.norstella-cf-open {\r\n  display: block;\r\n}\r\n\r\n.norstella-cf-popup-content {\r\n  position: relative;\r\n  min-width: 80%;\r\n  overflow-x: auto;\r\n  /* Horizontal scrolling */\r\n  overflow-y: auto;\r\n  /* Vertical scrolling */\r\n  margin: 0 auto;\r\n}\r\n\r\n.norstella-cf-scrollable-content {\r\n  margin-top: 50px;\r\n}\r\n\r\n#scrollable-note-content {\r\n  overflow-y: auto;\r\n  height: 100%;\r\n}\r\n\r\n.norstella-cf-note-content {\r\n  height: 350px;\r\n}\r\n\r\n.norstella-cf-close-button {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  color: #757575;\r\n}\r\n\r\n.norstella-cf-note-button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding-left: 0px;\r\n  padding-right: 0px;\r\n}\r\n\r\n.norstella-cf-close-button:hover {\r\n  color: #333;\r\n}\r\n\r\n/* Responsive styles */\r\n@media (max-width: 768px) {\r\n  .norstella-cf-popup {\r\n    width: 95%;\r\n    height: 80%;\r\n    max-width: none;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n\r\n  .norstella-cf-popupPAForm {\r\n    height: 70px;\r\n  }\r\n\r\n  .norstella-cf-popup-content {\r\n    min-width: 90%;\r\n    padding: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
